import type {
  AgentSessionListItem,
  AgentSessionSurface,
} from "@/lib/agentRunTransport";

export const SIDEBAR_SESSION_SURFACES: AgentSessionSurface[] = [
  "chat",
  "risk_assessment_workspace",
];

type SidebarSessionPage = {
  sessions: AgentSessionListItem[];
  page: number;
  totalPages: number;
};

const activityTime = (session: AgentSessionListItem): number => {
  const value = session.last_message_at ?? session.created_at;
  if (!value) return 0;
  const parsed = Date.parse(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

/**
 * Combine every user-facing session surface without grouping by agent. The
 * public session id is shared across surfaces and is the deduplication key.
 */
export function mergeSidebarSessionFeed(
  ...groups: AgentSessionListItem[][]
): AgentSessionListItem[] {
  const byId = new Map<string, AgentSessionListItem>();
  for (const session of groups.flat()) {
    if (!byId.has(session.id)) byId.set(session.id, session);
  }
  return [...byId.values()].sort(
    (left, right) => activityTime(right) - activityTime(left),
  );
}

export function combineSidebarSessionPages(pages: SidebarSessionPage[]) {
  return {
    sessions: mergeSidebarSessionFeed(...pages.map((page) => page.sessions)),
    hasMore: pages.some((page) => page.page < page.totalPages),
  };
}
